import { get, post } from '@/request/request'

export default {
    list() {
        return get('/admin/customer/tag/list')
    },
    save(params) {
        return post('/admin/customer/tag/save', params)
    },
    delete(params) {
        return post('/admin/customer/tag/delete', params)
    }

}